import React from 'react';
import { Caption, CaptionBold, HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/components/internationalMinutesTooltipStyle';
import { makeStyles } from '@material-ui/core';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { SingleDialingCode } from 'utils/api/models/numbers/singleDialingCode';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IInternationalMinutesTooltipProps {
	countries: string[];
	dialingCodes: SingleDialingCode[];
}

const InternationalMinutesTooltip = ({ countries, dialingCodes }: IInternationalMinutesTooltipProps) => {
	const classes = useStyles();
	return (
		<div>
			<HeadingSBold>{translate('services.international.minutes.destinations')}</HeadingSBold>
			<div className={classes.countries}>
				{countries.map((country) => (
					<div key={country}>
						<Caption inline disableMargin>
							{country}
						</Caption>
					</div>
				))}
			</div>
			<HeadingSBold>{translate('services.international.minutes.dialog.codes')}</HeadingSBold>
			<div className={classes.dialingCodes}>
				{dialingCodes.map((dialingCode) => (
					<div key={dialingCode.country} className={classes.dialingCode}>
						<div className={classes.dialingCountry}>
							<CaptionBold inline disableMargin>
								{dialingCode.country}
							</CaptionBold>
						</div>
						<div className={classes.codesArray}>
							{dialingCode.codes.map((code, index) => (
								<div key={code}>
									<Caption inline disableMargin>
										{String(code)}
									</Caption>
									<ConditionalRender
										show={index !== dialingCode.codes.length - 1}
										onTrue={() => (
											<Caption inline disableMargin>
												{', '}
											</Caption>
										)}
									/>
								</div>
							))}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default InternationalMinutesTooltip;
